import React from 'react';
import CategoryPage from '../components/category';

const Category = () => <CategoryPage />;

export default Category;
